<template>
	<el-dialog v-model="dialogShow" title="长抬杆" width="500px">
		<el-table :data="list" stripe border v-loading="loading">
			<el-table-column align="center" label="实付金额" prop="name"/>
			<el-table-column align="center" label="操作">
				<template #default="{row}">
					<el-button type="success" @click="open(row)">长抬杆</el-button>
					<el-button type="primary" @click="close(row)">取消长抬杆</el-button>
				</template>
			</el-table-column>
		</el-table>
		<template #footer>
			<div class="dialog-footer">
				<el-button type="primary" @click="dialogShow = false">关闭</el-button>
			</div>
		</template>
	</el-dialog>
</template>
<script>
import {mapState} from "vuex";
import {getCheckPointByQuery, openOrCloseDoor} from "@/network/api";
import {ElMessage} from "element-plus";

export default {
	data() {
		return {
			dialogShow: false, loading: false,
			list: [],
		};
	},
	computed: {
		...mapState(["carParkList", "carParkIndex"]),
	},
	methods: {
		show() {
			this.dialogShow = true;
			this.loading = true;
			const carParkId = this.carParkList[this.carParkIndex].areaId;
			const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
			getCheckPointByQuery({areaId: carParkId, deviceType: 2, page: 1, size: 100}).then(res => {
				this.list = res.data.filter(v => v.dutyUid === userInfo.id);
			}).finally(() => {
				this.loading = false;
			});
		},
		open({id}) {
			openOrCloseDoor({deviceId: id, action: 'on', ct: true}).then(() => {
				ElMessage({type: "success", message: "操作成功"});
			});
		},
		close({id}) {
			openOrCloseDoor({deviceId: id, action: 'cancelOn', ct: true}).then(() => {
				ElMessage({type: "success", message: "操作成功"});
			});
		}
	},
};
</script>
